<template>
  <section class="fine-porcelain mx-auto relative clearfix w">
    <div class="text-center">
      <div class="text-center content-title">
        <span class="inline-block line-css"></span>
        <span class="font-css">
          <span>御窑珍品瓷器</span> IMPERIAL KILN PORCELAIN TREASURES
        </span>
        <span class="inline-block line-css"></span>
      </div>
      <div class="relative clearfix">
        <ul class="s-list-imgs h-full clearfix">
          <li
            v-for="type in types"
            :key="`types_${type}`"
            class="w-1/2 float-left relative"
          >
            <div class="absolute li-mask">
              <ul v-if="defaults && defaults[type]" class="clearfix">
                <li
                  v-for="item in defaults[type]"
                  :key="item.name"
                  class="float-left cursor-pointer inline-block li-content"
                  @click="ceramicsClick(item, type)"
                >
                  {{ item.value }}
                </li>
              </ul>
              <div
                class="more absolute cursor-pointer"
                @click="
                  link({
                    type: 'link',
                    link: '/ceramic'
                  })
                "
              >
                全部 | ALL
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import link from '@/core/mixins/link'
export default {
  name: 'home-panorama',
  props: {},
  mixins: [link],
  data() {
    return {
      properties: {},
      defaults: null,
      types: ['dynasty', 'style', 'usage', 'location']
    }
  },
  watch: {
    schemaConfig() {
      this.getConditions() // 编辑瓷器搜索条件
    }
  },
  computed: {
    schemaConfig() {
      return this.$store.getters['SchemaConfigStore/schemaConfig']
    },
    homeCeramics() {
      let data = this.$store.getters['HomeStore/homeCeramics']
      if (data === false) {
        return false
      }
      return data.splice(0, 8)
    }
  },
  mounted: function() {
    this.getConditions() // 编辑瓷器搜索条件
  },
  methods: {
    // 获取瓷器搜索条件
    getConditions() {
      if (
        !this.schemaConfig ||
        !this.schemaConfig.properties ||
        !this.schemaConfig.properties.ceramic
      ) {
        return false
      }

      this.properties = Object.assign(
        {},
        this.schemaConfig.properties.ceramic.properties
      )
      let defaults = Object.assign(
        {},
        this.schemaConfig.properties.ceramic.default
      )
      for (let key in defaults) {
        let arr = []
        defaults[key] = defaults[key].reduce((total, currentValue) => {
          let condition = {
            name: currentValue,
            value: currentValue
          }
          arr.push(condition)
          return arr
        }, {})
      }

      this.defaults = defaults
    },
    ceramicsClick(item, type) {
      let query = {}
      query[type] = item.value
      this.link({
        type: 'link',
        link: '/ceramic',
        query
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.fine-porcelain {
  .fp-list-title {
    top: 20px;
    width: 33px;
  }

  .il-list-line {
    top: 132px;
    height: 40px;
  }
  .s-list-imgs {
    > li {
      height: 352px;
      background-color: #fff;
      background-repeat: no-repeat;
      background-size: cover;
      &:hover {
        .li-mask {
          opacity: 1;
          transition: all 0.35s;
          -moz-transition: all 0.35s;
          -webkit-transition: all 0.35s;
          -o-transition: all 0.35s;
        }
      }
    }
    > li:nth-child(1) {
      background-image: url('../../../static/images/home/firing-dynasty-bg.jpg');
    }
    > li:nth-child(2) {
      background-image: url('../../../static/images/home/category-bg.jpg');
    }
    > li:nth-child(3) {
      background-image: url('../../../static/images/home/device-use-bg.jpg');
    }
    > li:nth-child(4) {
      background-image: url('../../../static/images/home/unearthed-position-bg.jpg');
    }
    .li-mask {
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $c-transparent-8;
      .more {
        border-color: $c-font-yellow;
        color: $c-font-yellow;
        bottom: 26px;
        right: 22px;
        &:hover {
          color: $c-white;
          border-color: $c-white;
        }
      }
      > ul {
        padding: 22px;
        margin-top: 7%;
        max-height: 220px;
        overflow: hidden;
      }
    }
    .li-content {
      width: 114px;
      height: 40px;
      line-height: 38px;
      border: 1px solid $c-font-yellow;
      color: $c-font-yellow;
      margin: 15px 12px;
      &:hover {
        color: $c-white;
        border-color: $c-white;
      }
    }
  }

  .s-list-img {
    max-height: 177.5px;
  }
}
</style>
